/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Typography } from '@material-ui/core';
import { TreeView, TreeItem } from '@material-ui/lab';
import { css } from '@emotion/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { NumberHandler } from '../../util/NumberHandler';

const useStyles = makeStyles({
  root: {
    // height: 264,
    flexGrow: 1,
    width: 550,
  },
});

const useTreeItemStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.text.secondary,
    '&:focus > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)',
    },
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    boxSizing: 'border-box',
    fontWeight: theme.typography.fontWeightRegular,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2),
    },
  },
  expanded: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1,
  },
}));

const AccountingTreeBox = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
`;

const AmountBox = css`
  display: flex;
  .debitAmount {
    margin-right: 1.5rem;
  }

  .debitAmount,
  .creditAmount {
    font-weight: inherit;
    width: 80px;
    text-align: right;
    // & :before {
    //   content: '$';
    //   float: left;
    // }
  }
`;

const LabelBox = css`
  display: flex;
  justify-content: flex-end;
  padding-right: 8px;
  h6 {
    & :first-child {
      margin-right: 1.5rem;
    }
    width: 80px;
    text-align: right;
  }
`;

const StyledTreeItem = props => {
  const classes = useTreeItemStyles();
  const {
    labelText,
    labelIcon,
    DebitAmount,
    CreditAmount,
    color,
    bgColor,
    ...other
  } = props;

  return (
    <TreeItem
      label={
        <div className={classes.labelRoot}>
          <Typography variant="body1" className={classes.labelText}>
            {labelText}
          </Typography>
          <div css={AmountBox}>
            <Typography variant="body1" color="inherit" className="debitAmount">
              <NumberHandler num={DebitAmount} float={2} justify="flex-end" />
            </Typography>
            <Typography
              variant="body1"
              color="inherit"
              className="creditAmount"
            >
              <NumberHandler num={CreditAmount} float={2} justify="flex-end" />
            </Typography>
          </div>
        </div>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        group: classes.group,
        label: classes.label,
      }}
      {...other}
    />
  );
};

const CustomTreeView = ({ ATArray }) => {
  const classes = useStyles();
  if (!ATArray || ATArray.length === 0) return null;
  return (
    <div css={AccountingTreeBox}>
      <Typography variant="h4" gutterBottom>
        Accounting
      </Typography>
      <div>
        <div css={LabelBox}>
          <Typography variant="subtitle1">Debit</Typography>
          <Typography variant="subtitle1">Credit</Typography>
        </div>
        <TreeView
          className={classes.root}
          defaultCollapseIcon={<ArrowDropDownIcon />}
          defaultExpandIcon={<ArrowRightIcon />}
          defaultEndIcon={<div style={{ width: 24 }} />}
        >
          {ATArray.map((item, index) => {
            return (
              <StyledTreeItem
                key={`${index}`}
                nodeId={`${index}`}
                labelText={item.Name}
                DebitAmount={item.DebitAmount}
                CreditAmount={item.CreditAmount}
              >
                {item.Accounts.map((account, index2) => (
                  <StyledTreeItem
                    nodeId={`${index}${index2}`}
                    key={`${index}${index2}`}
                    labelText={account.Name}
                    DebitAmount={account.DebitAmount}
                    CreditAmount={account.CreditAmount}
                  />
                ))}
              </StyledTreeItem>
            );
          })}
        </TreeView>
      </div>
    </div>
  );
};

export default CustomTreeView;
